import React, { useCallback, useRef, useState } from 'react'
import { useAdminOffers } from './adminOffersHook'
import { Link, useHistory } from 'react-router-dom'

const dateformat = require('dateformat')
const formatCreatedAt = t => dateformat(t, "mm/dd HH:MM")

const formats = {
    status: {
        new: '未確',
        fix: '確定',
        cancel: '取消',
    },
    gozen: '午前',
    gogo: '午後',
    syujitu: 'チャーター',
    mitei: '未定',
    '3t': '3トン',
    '7t': '7トン',
    '13t': '15トン',
    '13th': '15平',
    nouhin: '納品',
    hikitori: '引き取り',
    nouhin_hikitori: '納品/引き取り',
    maezumi_ari: '前積あり',
    maezumi_nashi: '前積なし',
    maezumi_mitei: '前積未定',
    sectionWithTime: offer => {
        const t = dateformat(new Date(2020, 0, 1, offer.startHour, offer.startMinute, 0, 0), "HH:MM")
        switch (offer.section) {
            case 'gozen':
                return `【前】${t}`
            case 'gogo':
                return `【後】${t}`
            case 'mitei':
                return `時間未定`
            case 'syujitu':
                return `チャーター`
            default:
                return ``
        }
    },
}

const formatReserveDate = offer => {
    const d = new Date(offer.year, offer.month - 1, offer.day, offer.startHour, offer.startMinute, 0, 0)
    const kweeks = ['日', '月', '火', '水', '木', '金', '土']
    return dateformat(d, "yyyy/mm/dd") + `(${kweeks[d.getDay()]})`
}

const AdminOffersTable = () => {
    const refSearchForm = useRef()
    const history = useHistory()
    const { isLoading, offers, offersTotal: total, searchOpts, switchType, setPage, setCompanyName, users, setOrderBy } = useAdminOffers()
    const typ = searchOpts.typ
    const handleClickRow = useCallback(item => () => {
        history.push(`/admin/offers/${item.offerId}`)
    }, [history])
    const handleClickPast = useCallback(evt => {
        switchType("past")
    }, [switchType])
    const handleClickStd = useCallback(evt => {
        switchType("std")
    }, [switchType])
    const { page, perPage, companyName, orderBy } = searchOpts
    const pageMax = Math.ceil(total / perPage)

    const handleClickPage = useCallback(page => evt => {
        if (isLoading) {
            return
        }
        setPage(page)
    }, [isLoading, setPage])

    const handleClickOrderBy = orderBy => () => {
        setOrderBy(orderBy)
    }

    const handleSubmitSearchForm = useCallback(evt => {
        try {
            evt.preventDefault()
            if (isLoading) {
                return false
            }
            const form = refSearchForm.current
            setCompanyName(form.companyName.value)
            return false
        } catch (error) {
            console.log({ error })
            return false
        }
    }, [isLoading, setCompanyName])

    console.log({ page, pageMax, total })
    const renderPages = useCallback(() => {
        const a = []
        if (page > 1) {
            a.push(
                <div key="first" className="pg-first" onClick={handleClickPage(1)}></div>
            )
            a.push(
                <div key="prev" className="pg-prev" onClick={handleClickPage(page - 1)}></div>
            )
        }
        if (page < pageMax) {
            a.push(
                <div key="next" className="pg-next" onClick={handleClickPage(page + 1)}></div>
            )
            a.push(
                <div key="last" className="pg-last" onClick={handleClickPage(pageMax)}></div>
            )
        }
        return (
            <div className="pager">{a}</div>
        )
    }, [handleClickPage, page, pageMax])

    const handleChangeCompanyName = useCallback(evt => {
        setCompanyName(evt.target.value)
    }, [setCompanyName])

    return (
        <section className="contents">

            <div className="contents1000">
                <h2 className="adminTitle">申し込み一覧</h2>

                {typ === 'std' && (
                    <span className="link-button" onClick={handleClickPast}>→過去の予約日</span>
                )}
                {typ === 'past' && (
                    <span className="link-button" onClick={handleClickStd}>→今日以降の予約日</span>
                )}

                <form className="searchForm" ref={refSearchForm} onSubmit={handleSubmitSearchForm}>
                    {users && (
                        <>
                            <label>
                                <span>会社名</span>
                                <select name="companyName" value={companyName} onChange={handleChangeCompanyName}>
                                    <option value=""></option>
                                    {users.map(user => (
                                        <option value={user.companyName}>{user.companyName}</option>
                                    ))}
                                </select>
                                {/*
                                <input type="text" name="companyName" defaultValue={companyName} /></label>
                                */}
                            </label>
                            {/*
                            <button type="submit">検索</button>
                            */}
                        </>
                    )}
                </form>
                {renderPages()}


                <div className="slideTableBox">
                    <table className="adminTable">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>状況</th>
                                <th>
                                    {orderBy === 'createdAt' ?
                                        (
                                            <>申込日</>
                                        ) : (
                                            <span className="orderBy" onClick={handleClickOrderBy('createdAt')}>申込日</span>
                                        )
                                    }
                                </th>
                                <th>
                                    {orderBy === 'reserveDate' ?
                                        (
                                            <>予約日</>
                                        ) : (
                                            <span className="orderBy" onClick={handleClickOrderBy('reserveDate')}>予約日</span>
                                        )
                                    }
                                </th>
                                <th>時間</th>
                                <th>車体</th>
                                <th>業務</th>
                                <th>場所</th>
                                <th>会社名</th>
                            </tr>
                        </thead>
                        <tbody>
                            {offers.map(item => (
                                <tr key={item.offerId} onClick={handleClickRow(item)}>
                                    <td>{item.offerId}</td>
                                    <td>
                                        {item.status === 'cancel' && (
                                            <span className="cancel">取消</span>
                                        )}
                                        {item.status === 'new' && (
                                            <span className="mitei">未確</span>
                                        )}
                                        {item.status === 'fix' && (
                                            <span className="kakutei">確定</span>
                                        )}
                                    </td>
                                    <td>{formatCreatedAt(item.createdAt)}</td>
                                    <td>{formatReserveDate(item)}</td>
                                    <td>{formats.sectionWithTime(item)}</td>
                                    <td>{formats[item.grade]}</td>
                                    <td>{formats[item.task]}</td>
                                    <td>{item.basho}</td>
                                    <td>{item.userCompanyName}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <Link to="/admin" className="backBtn">管理画面トップに戻る</Link>
            </div>
        </section>
    )
}

export default AdminOffersTable

